import React, {useEffect} from 'react';
import {useParams, useNavigate, useLocation} from 'react-router-dom';
import {useQuery} from '@apollo/client';
import {Spin} from 'antd';
import {GET_SORTER_BY_ID} from './graphql/queries/getSorter';

/**
 * 分拣方案详情页路由守卫
 * 根据分拣机类型跳转到不同的详情页：
 * - sorterType = 1 (DWS) -> /wms/sorterPlan/dws/:id
 * - sorterType = 2 (交叉带) -> /wms/sorterPlan/crossbelt/:id
 * - sorterType = 5 (直线分拣机) -> /wms/sorterPlan/crossbelt/:id（复用交叉带详情页，与后端扫描路由复用一致）
 */
const SorterPlanDetailRouter: React.FC = () => {
    const {id} = useParams<{id: string}>();
    const navigate = useNavigate();
    const location = useLocation();

    // 从路由 state 中获取 sorterId（列表页传递）
    const sorterId = location.state?.sorterId;

    // 根据 sorterId 查询分拣机信息，获取 sorterType
    const {data: sorterData, loading: sorterLoading, error: sorterError} = useQuery(GET_SORTER_BY_ID, {
        variables: {id: sorterId?.toString() || ''},
        skip: !sorterId,
        fetchPolicy: 'network-only',
    });

    useEffect(() => {
        if (sorterData?.getSorterById) {
            const sorterType = sorterData.getSorterById.sorterType;

            if (sorterType === 1) {
                // DWS 类型，跳转到 DWS 详情页
                navigate(`/wms/sorterPlan/dws/${id}`, {replace: true});
            } else if (sorterType === 2 || sorterType === 5) {
                // 交叉带 / 直线分拣机类型，复用交叉带详情页（与后端扫描路由复用交叉带逻辑一致）
                navigate(`/wms/sorterPlan/crossbelt/${id}`, {replace: true});
            } else {
                // 未知类型，返回列表页
                console.error('未知的分拣机类型:', sorterType);
                navigate('/wms/sorterPlan', {replace: true});
            }
        }
    }, [sorterData, id, navigate]);

    useEffect(() => {
        if (sorterError) {
            console.error('查询失败:', sorterError);
            navigate('/wms/sorterPlan', {replace: true});
        }
    }, [sorterError, navigate]);

    return (
        <div className="flex items-center justify-center h-screen">
            <Spin size="large" tip="加载中..." />
        </div>
    );
};

export default SorterPlanDetailRouter;
